/* eslint-disable @typescript-eslint/no-var-requires */
import React, { useEffect, useRef, useState } from 'react';
import { usePlayFlag } from './../../components/topicScroll';
import ImgSocialMedia from '../../../../../assets/social-media.gif';
import ImgArrowLeft from '../../../../../assets/arrow-left-long.png';
import ImgArrowRight from '../../../../../assets/arrow-right-long.png';
import ImgPoint from '../../../../../assets/animation_point.gif';

import { Button, Modal } from 'antd';
import './animation006.less';

interface IAnimation006SubItem {
  img: string;
  title: string;
  link: string;
}
interface IAnimation006Item {
  content: string;
  tip?: string;
  subItems?: IAnimation006SubItem[];
}

interface IAnimation006Props {
  title?: string | null;
  items: IAnimation006Item[];
  onCompleted?: () => void;
}

const Animation006: React.FunctionComponent<IAnimation006Props> = ({
  title,
  items,
  onCompleted,
}) => {
  const [palySocialMedia, setPalySocialMedia] = React.useState(1);
  const crrRef = useRef() as React.MutableRefObject<HTMLDivElement>;
  const playFlag = usePlayFlag(crrRef.current as HTMLElement, '.course-body');
  const startPlay = (next = 1) => {
    setPalySocialMedia(next);
    next += 1;
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1000);
    } else {
      onCompleted && onCompleted();
    }
  };
  useEffect(() => {
    if (playFlag) {
      startPlay();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [playFlag]);

  const [isModalOpen, setModalOpen] = useState(false);

  const [currPage, setCurrPage] = useState(0);

  const setPage = (pagePlus: number) => {
    setCurrPage(currPage + pagePlus);
  };

  const [modalItem, setModalItem] = useState<IAnimation006SubItem[]>();

  const [show, setShow] = useState(true);

  return (
    <div ref={crrRef} className="animation006">
      <div className="animation006-bg" />
      {title ? (
        <div
          className="animation006-radius"
          dangerouslySetInnerHTML={{
            __html: title,
          }}
        />
      ) : (
        <img className="animation006-gif" src={ImgSocialMedia} alt="" />
      )}
      {items.map((itm: IAnimation006Item, idx: number) => (
        <div
          key={idx}
          className={`animation006-panel s${idx + 1} animation  ${
            palySocialMedia >= idx + 1 ? 'fade-in' : ''
          }`}
        >
          <div className="animation006-content">
            <div className="indicator">{idx + 1}</div>
            {itm.content}
            {itm.subItems ? (
              <div className="view-more">
                <Button
                  className="view-more-btn"
                  onClick={() => {
                    setModalItem(itm.subItems);
                    setModalOpen(true);
                    setShow(false);
                  }}
                  type="link"
                >
                  {itm.tip}
                  <img
                    className="click-point1"
                    hidden={!show}
                    src={ImgPoint}
                    alt=""
                  />
                </Button>
              </div>
            ) : null}
          </div>
        </div>
      ))}
      {modalItem && (
        <Modal
          width="60%"
          className="animation006-modal"
          title={
            <div className="animation006-modal-header">
              <div className="animation006-modal-title">
                {modalItem[currPage]?.title}
              </div>
              <div className="animation006-modal-link">
                <a href={modalItem[currPage]?.link}>
                  {modalItem[currPage]?.link}
                </a>
              </div>
            </div>
          }
          footer={null}
          visible={isModalOpen}
          onCancel={() => setModalOpen(false)}
        >
          <Button
            className={`prev-button ${currPage === 0 ? 'hide' : ''}`}
            type="text"
            disabled={currPage === 0}
            onClick={() => setPage(-1)}
          >
            <img src={ImgArrowLeft} alt="" />
          </Button>
          <img
            src={
              require(`../../../../../assets/${modalItem[currPage]?.img}`)
                .default
            }
            alt=""
          />
          <Button
            className={`next-button ${
              currPage === modalItem.length - 1 ? 'hide' : ''
            }`}
            type="text"
            disabled={currPage === modalItem.length - 1}
            onClick={() => setPage(1)}
          >
            <img src={ImgArrowRight} alt="" />
          </Button>
        </Modal>
      )}
    </div>
  );
};

Animation006.defaultProps = {
  title: null,
};

export default Animation006;
